import Supercluster from 'supercluster'

export const scOptions = {
  radius: 100,
  maxZoom: 17,
}

export const sc = new Supercluster(scOptions)
